import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppState } from "../../../store";
import fetchAPI, { ApiResponse, HttpMethod } from "../../../utils/api";
import bookingPageSlice, { Booking } from "../../booking-page/store/slice";
import { showSuccess } from "../../toaster/store/slice";
import { User } from "../../users/store/slice";
import bookingShowSlice from "./slice";

type BookingResponse = ApiResponse<{ data: Booking }>;
type AssignResponse = ApiResponse<{ success: boolean }>;

function* bookingShowSaga() {
  yield takeLatest(bookingShowSlice.actions.fetchData, handleFetch);
  yield takeLatest(bookingShowSlice.actions.cancel, handleCancel);
  yield takeLatest(bookingShowSlice.actions.assign, handleAssign);
}

function* handleFetch({ payload: id }: PayloadAction<number>) {
  const response: BookingResponse = yield call(fetchAPI, `/bookings/${id}`);

  if (response && response.data) {
    yield put(bookingShowSlice.actions.setData(response.data));
  }

  yield put(bookingShowSlice.actions.setIsLoading(false));
}

function* handleCancel({ payload: id }: PayloadAction<number>) {
  const response: BookingResponse = yield call(
    fetchAPI,
    `/bookings/${id}/cancel`,
    {
      method: HttpMethod.POST,
    }
  );

  if (response && response.data) {
    yield put(bookingShowSlice.actions.setData(response.data));

    yield put(showSuccess("Cancellation requested."));

    yield put(bookingPageSlice.actions.fetchData());
  }

  yield put(bookingShowSlice.actions.setIsLoading(false));
}

function* handleAssign({
  payload: { bookingId, userId },
}: PayloadAction<{ bookingId: number; userId: number }>) {
  const response: AssignResponse = yield call(
    fetchAPI,
    `/bookings/${bookingId}/assign/${userId}`,
    {
      method: HttpMethod.POST,
    }
  );

  if (response && response.success) {
    const user: User = yield select((state: AppState) =>
      state.users.data.find((user) => user.id === userId)
    );

    yield put(bookingShowSlice.actions.setOwner(user));

    yield put(showSuccess(`${user.name} notified via email.`));
  }

  yield put(bookingShowSlice.actions.setIsAssigning(false));
}

export default bookingShowSaga;
